module.exports = __webpack_public_path__ + "static/media/logo.9c2c365a.svg";